// extracted by mini-css-extract-plugin
export var addButton = "_5o-d";
export var bullets = "_5o-e";
export var compact = "_5o-2";
export var container = "_5o-j";
export var extendedWarrantyModal = "_5o-f";
export var learn = "_5o-l";
export var learnMore = "_5o-g";
export var offeringOption = "_5o-3";
export var offeringPrice = "_5o-8";
export var offeringSubtitle = "_5o-7";
export var offeringTitle = "_5o-6";
export var offeringsContainer = "_5o-0";
export var pdpTilesBackground = "_5o-n";
export var plan = "_5o-m";
export var regular = "_5o-1";
export var remove = "_5o-k";
export var seeDetailsIcon = "_5o-i";
export var seeDetailsLink = "_5o-h";
export var selectedOption = "_5o-4";
export var shieldIcon = "_5o-b";
export var shieldIconCompact = "_5o-c";
export var subtitle = "_5o-a";
export var title = "_5o-9";
export var unselectedOption = "_5o-5";